<app-breadcrumb [master]="'Struktura sieci'" [parentName]="'TU'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group  *ngIf="companyObject">
  <mat-tab label="Dane">
    <div class="company-data" fxLayout="column" fxLayoutGap="15px" *ngIf="!modifyBoolean" >
      <div fxLayout="row" fxLayoutGap="15px" *ngIf="companyObject">
        <button [disabled]="!(userPermissions | async).insurance_company.write" (click)="setImage()" mat-stroked-button color="primary"><mat-icon>file_upload</mat-icon> <span> Zmień zdjęcie</span></button>

        <button [disabled]="!(userPermissions | async).insurance_company.write" (click)="toggleRegistrations()" mat-stroked-button color="primary">
          <mat-icon>{{companyObject.blockRegistrations ? 'lock_open' : 'lock'}}</mat-icon>
          <span> {{companyObject.blockRegistrations ? 'Odblokuj' : 'Zablokuj'}} rejestracje
          </span>
        </button>
        <button  [disabled]="!(userPermissions | async).insurance_company.write" (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>

      </div>

      <mat-card *ngIf="companyObject">
        <div fxLayout="row" fxLayoutGap="15px">
          <div>
            <div (click)="setImage()" class="user-avatar" *ngIf="companyObject.imageLocation"
                 matRipple
                 [matRippleCentered]="false"
                 [matRippleDisabled]="false"
                 [matRippleUnbounded]="false"
                 [matRippleRadius]="10"
                 [matRippleColor]="'grey'" >
              <img src="/rest/crm/insuranceCompany/{{companyObject.id}}/image?{{imgCnt}}" alt="Zdjęcie" height="60"/>
            </div>
            <div>
              <span fxFlex></span>
            </div>
            <input #imageSelect type="file" style="display: none" [formControl]="imageSelectControl"
                   accept=".jpg,.gif,.png,.jpeg"/>
          </div>
          <div>
            <h3>Dane TU</h3>
          </div>
        </div>

        <div fxLayoutGap="15px" fxLayout="row" fxLayout.lt-md="column">
          <div fxFlex="50">
            <app-detail header="Nazwa" [value]="companyObject.name"></app-detail>
          </div>

          <div fxFlex="100">
            <app-detail header="Typ" [value]="companyObject.type?.name"></app-detail>
          </div>

        </div>

        <div fxLayoutGap="15px" fxLayout="row" fxLayout.lt-md="column">
          <div fxFlex="100">
            <app-detail header="Pełna nazwa" [value]="companyObject.fullName"></app-detail>
          </div>
        </div>
      </mat-card>
      <mat-card *ngIf="companyObject">
        <div fxLayout="row">
          <h3>Firmy</h3>
        </div>

        <div fxLayout="column" fxLayoutGap="15px">
          <div fxFlex="100">
            <app-detail-bool header="ASF Grzegorz Adamczuk" [value]="hasAsf"></app-detail-bool>
          </div>

          <div fxFlex="100">
            <app-detail-bool header="ASF Premium" [value]="hasAsfPremium"></app-detail-bool>
          </div>
          <div fxFlex="100">
            <app-detail-bool header="Multisfera" [value]="hasMultisfera"></app-detail-bool>
          </div>
        </div>

      </mat-card>

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3> Linki do portali</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <ng-container *ngFor="let link of companyObject.linkToPortal; let i = index">
                  <div fxLayout="row" fxLayoutGap="15px">
                    <span class="link-counter" fxFlex="5">{{i+1}}.</span>
                    <app-detail fxFlex="45" header="Nazwa">{{link.name}}</app-detail>
<!--                    <app-detail fxFlex="45" header="Link">{{link.link}}</app-detail>-->
                    <app-detail  fxFlex="45" header="Link"  matTooltip="{{link.link}}" (click)="copyMessage(link.link)"
                              class="id-mat">{{(link.link.length>35) ? (link.link | slice:0:35)+'...':(link.link)}}</app-detail>
                  </div>
                </ng-container>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3> Kontakt</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <ng-container >
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail  fxFlex="50" header="Infolinia"  >{{companyObject.contactHelpline }}</app-detail>
                    <app-detail fxFlex="50" header="Adres email">{{companyObject.contactEmail}}</app-detail>
                  </div>
                </ng-container>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Wymogi szkoleniowe</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <ng-container >
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail
                      fxFlex="30"
                      header="Majątek"
                    >
                      {{floor(companyObject.requiredAssetsMinutes / 60).toString() | number:'1.0-0'}}h
                      {{floor(companyObject.requiredAssetsMinutes % 60).toString() | number:'1.0-0'}}min
                    </app-detail>

                    <app-detail
                      fxFlex="30"
                      header="Życie"
                    >
                      {{floor(companyObject.requiredLifeMinutes / 60).toString() | number:'1.0-0'}}h
                      {{floor(companyObject.requiredLifeMinutes % 60).toString() | number:'1.0-0'}}min
                    </app-detail>

                    <app-detail
                      fxFlex="30"
                      header="Ogólne"
                    >
                      {{floor(companyObject.requiredGeneralMinutes / 60).toString() | number:'1.0-0'}}h
                      {{floor(companyObject.requiredGeneralMinutes % 60).toString() | number:'1.0-0'}}min
                    </app-detail>
                  </div>
                </ng-container>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
    </div>

    <app-add-insurance-company *ngIf="modifyBoolean"  [insuranceCompany]="company" (closeModification)="modifyBoolean = false; loadCompany()"></app-add-insurance-company>

  </mat-tab>
  <mat-tab label="Rejestracje">
    <ng-template matTabContent>

      <app-all-registrations-list
        [insuranceCompanyId]="companyObject.id" [disableFilters]="true" [disableBreadcrumb]="true"
        [excludeColumns]="['insuranceCompany', 'passedExam100p', 'passedExam40p', 'signedUpForAnExam', 'examPassed', 'sentToRegister', 'deregistrationPack', 'trainingRequirement', 'requirementMet']"
        [embeddedView]="true"
      >
      </app-all-registrations-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Identyfikatory">
    <ng-template matTabContent>
      <app-all-identifiers-list
        *ngIf="companyObject"
        [disableBreadcrumb]="true"
        [disableFilters]="true"
        [insuranceCompanyId]="companyObject.id"
        [excludeColumns]="['insuranceCompany']"
        [embeddedView]="true"
      ></app-all-identifiers-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Egzaminy/Szkolenia">
    <ng-template matTabContent>
      <app-all-meetings-list
        [embeddedView]="true"
        [disableFilters]="true"
        [disableBreadcrumb]="true"
        [displayedColumns]="['meeting', 'logo', 'insuranceCompany', 'leader', 'startsAt',
        'status', 'examType', 'place', 'linkOrAddress', 'limitOfPeople', ]"
        [insuranceCompany]="companyObject.id"
      ></app-all-meetings-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [insuranceCompany]="company"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
